<template>
  <tr v-if="row">
        
        <td>
          <div>  
            <div v-if="!row.meta.isEditing">
              <a href="javascript:void(0);" v-on:click="willEdit(row)">edit</a>
              <a href="javascript:void(0);" v-on:click="toggleAdvanced(row)">⚙️</a>
              <div v-if="row.meta.showAdvanced">
                
              </div>
            </div>  
            <div v-if="row.meta.isEditing">
              <a href="javascript:void(0);" v-on:click="saveEdit(row)">save</a>
            </div>  
          </div>
        </td>
        
        <td>
          <div>
            {{row.data.ItemNum}}
          </div>
        </td>

        <td>
          <div v-if="row.meta.isEditing">
            <input type="text" v-model="row.data.ItemName">
          </div>
          <div v-else>
            {{row.data.ItemName}}
          </div>
        </td>
        <td>
          <div v-if="row.meta.isEditing">
            <!-- <input type="text" v-model="row.data.department.Dept_ID"> -->
          </div>
          <div v-else>
            <!-- {{row.data.department.Description}} -->
            <DepartmentSelector v-model="row.data.Dept_ID" :departments="departments" @input="updateDepartment()"/>
          </div>
        </td>

        
        <!-- Reorder_Quantity is actually the number per case -->
        <td v-for="key in ['Price', 'Cost']" :key="key">
          <div v-if="row.meta.isEditing">
            <input type="text" v-model="row.data[key]">
          </div>
          <div v-else>
            {{row.data[key]}}
          </div>
        </td>
        
        <td>
          <div v-if="row.meta.isEditing">
            <input type="text" v-model="row.data.Last_Sold">
          </div>
          <div v-else>
            {{row.data.Last_Sold | formatDate}}
          </div>
        </td>

        <!-- <td>
          <div v-if="row.data.inventoryJson">
            {{row.data.inventoryJson.JSON}}
          </div>
        </td> -->

        <td>
          <div v-if="row.data.inventoryJson">
            
            <DistributorSelector v-model="row.data.inventoryJson.Distributor" @input="updateDistributor()"/>

          </div>
        </td>
        
      </tr>
</template>

<script>
import DistributorSelector from './DistributorSelector.vue'
import DepartmentSelector from './DepartmentSelector.vue'
export default {
  props: ['row', 'location', 'departments'],
  components: {DistributorSelector, DepartmentSelector},
  watch: { 
    // 'row.data': {
    //   handler: function(nVal, oVal){
    //     if (nVal.ItemNum === oVal.ItemNum && nVal.inventoryJson.Distributor !== oVal.inventoryJson.Distributor){
    //       console.log('will update')
    //     }
    //   },
    //   deep: true
    // }

  },

  methods:{
    updateDistributor: function(){
      let updateData = {
        Store_ID: '1001', 
        ItemNum : this.row.data.ItemNum, 
        JSON : JSON.stringify({}),
        Distributor: this.row.data.inventoryJson.Distributor,
      }
      this.$axios.patch(`/api/${this.location}/inventoryJson`, updateData).then(console.log)
    },
    updateDepartment: function(){
      console.log('updateDepartment', this.row.data.Dept_ID)
      let updateData = {Dept_ID : this.row.data.Dept_ID}
      this.$axios.put(`/api/${this.location}/inventory/${this.row.data.ItemNum}`, updateData).then(console.log)
    },
    willEdit: function(row){
      row.meta.isEditing = true;
    }
  },
  filters: {
    formatDate: function(val){
      return moment(val).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>

</style>
